import React from 'react';

import messages from './Messages';
import Select from 'components/Select';
import { IOption } from 'components/Select/Select';
import { CompanyMembersCount, CompanyMembersFilterBox } from './styles';
import { convertNumbersToProperFormat } from 'utils/number';
import Button from '../../../components/Button/Button';
import Icon from '../../../components/Icon/Icon';
import { getLanguageBaseOnTZ } from '../../../utils/LanguageLocalStorage';
import i18n from '../../../i18n';

interface IComponentProps {
  membersCount: number;
  rolesToSearch: IOption[];
  setNameToSearch: (nameToSearch: string) => void;
  companyRoleOptions: IOption[];
  onSetRolesToSearch: (roles: IOption[]) => void;
  withErrorUsersCount: number;
  withErrorRolesCount: number;
  viewState: 'default' | 'errorUsers' | 'errorRoles';
  setViewState: (viewState: 'default' | 'errorUsers' | 'errorRoles') => void;
  onExport: () => Promise<any>;
  initName?: string;
}

interface IComponentStates {
  inputValue: string;
  loadingExport: boolean;
}

class CompanyMembersFilters extends React.PureComponent<
  IComponentProps,
  IComponentStates
> {
  state: IComponentStates = {
    inputValue: '',
    loadingExport: false,
  };

  handleChangeName = (value: string) => {
    this.setState({ inputValue: value }, () => {
      this.props.setNameToSearch(this.state.inputValue);
    });
  };

  handleExport = async () => {
    this.setState({ loadingExport: true });
    try {
      await this.props.onExport();
      this.setState({ loadingExport: false });
    } catch (e) {
      this.setState({ loadingExport: false });
    }
  };

  render() {
    const {
      membersCount,
      rolesToSearch,
      companyRoleOptions,
      onSetRolesToSearch,
    } = this.props;
    const { loadingExport } = this.state;
    const arrowType =
      getLanguageBaseOnTZ() === 'fa' ? 'arrow-left' : 'arrow-right';
    return (
      <CompanyMembersFilterBox>
        {this.props.viewState === 'default' && (
          <Select
            // label={messages.searchByRole}
            placeholder={i18n.t('searchByRole', { ns: 'companyManagement' })}
            values={rolesToSearch}
            options={companyRoleOptions}
            multiChoice={true}
            onChangeValues={onSetRolesToSearch}
            onSearch={this.handleChangeName}
            containerStyle={{ flexGrow: 1 }}
            textInputStyle={{ minWidth: '180px' }}
            inputStyle={{ minWidth: '180px' }}
            initSearchText={this.props.initName}
          />
        )}

        {this.props.viewState !== 'errorRoles' && (
          <CompanyMembersCount>
            <span>
              {i18n.t('membersCount', { ns: 'companyManagement' }) as string}
            </span>
            <span>
              {this.props.viewState === 'errorUsers'
                ? this.props.withErrorUsersCount
                : convertNumbersToProperFormat(membersCount)}
            </span>
          </CompanyMembersCount>
        )}
        <div style={{ flex: 1 }}></div>
        {this.props.viewState === 'default' &&
          this.props.withErrorUsersCount > 0 && (
            <Button
              onClick={() => this.props.setViewState('errorUsers')}
              color="red-outline"
            >
              <Icon style={{ marginInlineStart: '5px' }} type={arrowType} />
              {messages.usersWithErrorFound(this.props.withErrorUsersCount)}
            </Button>
          )}
        {this.props.viewState === 'default' &&
          this.props.withErrorRolesCount > 0 && (
            <Button
              onClick={() => this.props.setViewState('errorRoles')}
              color="red-outline"
            >
              <Icon style={{ marginInlineStart: '5px' }} type={arrowType} />
              {messages.rolesWithErrorFound(this.props.withErrorRolesCount)}
            </Button>
          )}
        {this.props.viewState !== 'default' && (
          <Button
            onClick={() => this.props.setViewState('default')}
            color="red-outline"
            style={{ margin: '14px 0' }}
          >
            {i18n.t('dismissErrorView', { ns: 'companyManagement' }) as string}
            <Icon style={{ marginInlineStart: '5px' }} type={'rotate-ccw'} />
          </Button>
        )}
        {this.props.viewState === 'default' && (
          <Button
            onClick={this.handleExport}
            loading={loadingExport}
            color="green-outline"
          >
            <Icon
              type="download"
              title={i18n.t('excel', { ns: 'companyManagement' })}
            />
          </Button>
        )}
      </CompanyMembersFilterBox>
    );
  }
}

export default CompanyMembersFilters;
